import * as ko from "knockout";
import { EconomyApi } from "../Apis/EconomyApi";
import { CoOpStatementYear } from "../Models/Economy/CoOpStatementYear";

export class CoOpStatementsViewModel {
    private economyApi: EconomyApi;
    coOpStatementYears = ko.observableArray<CoOpStatementYear>();
    private $balanceSpan: JQuery;
    private $balanceField: JQuery;
    //private $weOweYou: JQuery;
    //private $youOweUs: JQuery;
    private $content: JQuery;
    loading = ko.observable<boolean>(false);
    noData = ko.observable<boolean>(false);

    constructor() {
        this.economyApi = EconomyApi.getInstance();
        this.$balanceSpan = $("#balanceField");
        this.$balanceSpan = $("#balanceSpan");
        //this.$weOweYou = $("#weOweYou");
        //this.$youOweUs = $("#youOweUs");
        this.$content = $(".statement-content");
    }

    init(): void {
        this.$content.hide();
        //this.$weOweYou.hide();
        //this.$youOweUs.hide();
        this.loading(true);
        this.$content.addClass("d-none");
        this.$content.css("display", "none");
        this.economyApi.getCoOpStatements().then((res) => {
            console.log(res);
            if (res.length === 0) {
                this.loading(false);
                this.noData(true);
                return;
            } else {
                this.noData(false); 
            }
            let balance = res[0].CoOpStatements[0].Balance;

            this.$balanceSpan.text(Math.abs(balance)
                .toLocaleString('da-DK', { maximumFractionDigits: 2, minimumFractionDigits: 2 }));

            //if (balance <= 0) {
            //    this.$youOweUs.show();
            //    this.$weOweYou.hide();
            //} else if (balance >= 0) {
            //    this.$youOweUs.hide();
            //    this.$weOweYou.show();
            //}

            this.coOpStatementYears(res);

            ($('.accountStatementFooTable') as any).footable();

            this.delay(150).then(() => {
                this.loading(false);
                this.$content.removeClass("d-none");
                this.$content.css("display", "inline");
            });
        });


    }

    private delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
}